<template>
  <div class="flash-card-deck">
    <div class="container">
      <div class="row">
        <div class="col offset-2 col-8">
          <DeckHeader :deck="deck" />
          <Study mode="review" :deck="deck" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeckHeader from '@itbpbg/lms-components/src/Flashcards/DeckHeader.vue';
import Study from '@itbpbg/lms-components/src/Flashcards/Study.vue';
import global from '@itbpbg/lms-components/src/mixins/global';
import cookies from 'js-cookie';

export default {
  components: {
    DeckHeader,
    Study,
  },
  mixins: [global],
  async asyncData({
    $axios, route, error, req, $globalHelper,
  }) {
    const deck = await $axios.$get(`/flashcards/${route.params.slug}?review=1&resetReview=1`).catch(() => false);
    if (!deck) {
      return error({ statusCode: 404, message: 'Page not found' });
    }

    let review;
    if (process.server) {
      const parsedCookies = $globalHelper.parseCookies(req.headers.cookie);
      review = parsedCookies.review_cards;
    } else {
      review = cookies.get('review_cards');
    }
    deck.lastReviewedCard = 0;
    if (review) {
      const data = JSON.parse(review);
      if (data[deck.id]) {
        deck.lastReviewedCard = deck.cards.length !== data[deck.id] ? data[deck.id] : 0;
      }
    }
    return { deck };
  },
  head() {
    const metaTitle = `${this.deck.metatitle} – Review Deck`;
    const metaDescription = this.deck.metadescription;

    return {
      titleTemplate: `${metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps({
        ...this.deck,
        metaTitle,
        metaDescription,
      }),
    };
  },
};
</script>
